import { render } from "./Multi.vue?vue&type=template&id=6d475477&scoped=true"
import script from "./Multi.vue?vue&type=script&lang=js"
export * from "./Multi.vue?vue&type=script&lang=js"

import "./Multi.vue?vue&type=style&index=0&id=6d475477&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d475477"]])

export default __exports__